var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductForm',{attrs:{"title":"Update product","request-tag":_vm.requestTag,"product":_vm.product},on:{"save":_vm.onSave,"close":function($event){return _vm.$router.back()},"blueprint":_vm.onBluePrintChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }